import { EditProjectContextProps } from "../../../EditProjectContext";
import { LtlPipelineViewModel } from "../../../../ViewModel/LtlPipelineViewModel";
import { setLtlBidpackAndShipFrequency } from "../SetLtlBidpackAndShipFrequency";

export const useHandleLtlTabChange = (editProjectContext: EditProjectContextProps) => {
  const addOrUpdateLaunchBatch = (spdrOrPdsrId: number, launchBatch: number | undefined) => {
    if (!spdrOrPdsrId) {
      return;
    }
    const { project, setProject } = editProjectContext;
    let ltlpipeline = {};
    const ltlPipelines = project?.ltlPipelines?.map((item: LtlPipelineViewModel) => {
      if (item.SpdrId !== spdrOrPdsrId && item.PdsrId !== spdrOrPdsrId) {
        return item;
      }
      ltlpipeline = {
        ...item,
        LaunchBatch: launchBatch,
      };
      return ltlpipeline;
    });

    setLtlBidpackAndShipFrequency(spdrOrPdsrId, ltlpipeline, editProjectContext);
    setProject({ ...project, ltlPipelines });
  };
  return { addOrUpdateLaunchBatch };
};
